function copyURI(evt) {
	evt.preventDefault();
	const button = evt.currentTarget;
	
	navigator.clipboard.writeText(window.location.href).then(() => {
		// Store original content
		const originalHTML = button.innerHTML;
		const originalLabel = button.getAttribute('aria-label');
		
		// Create a checkmark icon
		const checkIcon = `
			<svg width="21" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 100%; height: 100%;">
				<path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>
		`;
		
		// Show success feedback
		button.innerHTML = checkIcon;
		button.setAttribute('aria-label', 'Link copied!');
		button.style.color = '#021769';
		
		// Reset after 2 seconds
		setTimeout(() => {
			button.innerHTML = originalHTML;
			if (originalLabel) {
				button.setAttribute('aria-label', originalLabel);
			}
			button.style.color = '';
		}, 2000);
	}).catch(err => {
		console.error('Failed to copy link:', err);
	});
}

const copyLinks = document.querySelectorAll('.copy-btn, .copy-link-btn');

for (const copyLink of copyLinks) {
	copyLink.addEventListener('click', copyURI)
}
